export const CountryList = {
   "AF": {
      "id": "AF",
      "name": "Afghanistan",
      "code": "+93",
      "url": "https://flagcdn.com/w320/af.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "AL": {
      "id": "AL",
      "name": "Albania",
      "code": "+355",
      "url": "https://flagcdn.com/w320/al.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "DZ": {
      "id": "DZ",
      "name": "Algeria",
      "code": "+213",
      "url": "https://flagcdn.com/w320/dz.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "AS": {
      "id": "AS",
      "name": "AmericanSamoa",
      "code": "+1684",
      "url": "https://flagcdn.com/w320/as.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "AD": {
      "id": "AD",
      "name": "Andorra",
      "code": "+376",
      "url": "https://flagcdn.com/w320/ad.png",
      "phoneLength": 6,
      "formatLength": 8
   },
   "AO": {
      "id": "AO",
      "name": "Angola",
      "code": "+244",
      "url": "https://flagcdn.com/w320/ao.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "AI": {
      "id": "AI",
      "name": "Anguilla",
      "code": "+1264",
      "url": "https://flagcdn.com/w320/ai.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "AQ": {
      "id": "AQ",
      "name": "Antarctica",
      "code": "+672",
      "url": "https://flagcdn.com/w320/aq.png",
      "phoneLength": 6,
      "formatLength": 8
   },
   "AG": {
      "id": "AG",
      "name": "Antigua and Barbuda",
      "code": "+1268",
      "url": "https://flagcdn.com/w320/ag.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "AR": {
      "id": "AR",
      "name": "Argentina",
      "code": "+54",
      "url": "https://flagcdn.com/w320/ar.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "AM": {
      "id": "AM",
      "name": "Armenia",
      "code": "+374",
      "url": "https://flagcdn.com/w320/am.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "AW": {
      "id": "AW",
      "name": "Aruba",
      "code": "+297",
      "url": "https://flagcdn.com/w320/aw.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "AU": {
      "id": "AU",
      "name": "Australia",
      "code": "+61",
      "url": "https://flagcdn.com/w320/au.png",
      "phoneLength": 6,
      "formatLength": 8
   },
   "AT": {
      "id": "AT",
      "name": "Austria",
      "code": "+43",
      "url": "https://flagcdn.com/w320/at.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "AZ": {
      "id": "AZ",
      "name": "Azerbaijan",
      "code": "+994",
      "url": "https://flagcdn.com/w320/az.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "BS": {
      "id": "BS",
      "name": "Bahamas",
      "code": "+1242",
      "url": "https://flagcdn.com/w320/bs.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "BH": {
      "id": "BH",
      "name": "Bahrain",
      "code": "+973",
      "url": "https://flagcdn.com/w320/bh.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "BD": {
      "id": "BD",
      "name": "Bangladesh",
      "code": "+880",
      "url": "https://flagcdn.com/w320/bd.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "BB": {
      "id": "BB",
      "name": "Barbados",
      "code": "+1246",
      "url": "https://flagcdn.com/w320/bb.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "BY": {
      "id": "BY",
      "name": "Belarus",
      "code": "+375",
      "url": "https://flagcdn.com/w320/by.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "BE": {
      "id": "BE",
      "name": "Belgium",
      "code": "+32",
      "url": "https://flagcdn.com/w320/be.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "BZ": {
      "id": "BZ",
      "name": "Belize",
      "code": "+501",
      "url": "https://flagcdn.com/w320/bz.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "BJ": {
      "id": "BJ",
      "name": "Benin",
      "code": "+229",
      "url": "https://flagcdn.com/w320/bj.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "BM": {
      "id": "BM",
      "name": "Bermuda",
      "code": "+1441",
      "url": "https://flagcdn.com/w320/bm.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "BT": {
      "id": "BT",
      "name": "Bhutan",
      "code": "+975",
      "url": "https://flagcdn.com/w320/bt.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "BO": {
      "id": "BO",
      "name": "Bolivia, Plurinational State of Bolivia",
      "code": "+591",
      "url": "https://flagcdn.com/w320/bo.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "BA": {
      "id": "BA",
      "name": "Bosnia and Herzegovina",
      "code": "+387",
      "url": "https://flagcdn.com/w320/ba.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "BW": {
      "id": "BW",
      "name": "Botswana",
      "code": "+267",
      "url": "https://flagcdn.com/w320/bw.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "BV": {
      "id": "BV",
      "name": "Bouvet Island",
      "code": "+55",
      "url": "https://flagcdn.com/w320/bv.png",
      "phoneLength": 11,
      "formatLength": 16
   },
   "BR": {
      "id": "BR",
      "name": "Brazil",
      "code": "+55",
      "url": "https://flagcdn.com/w320/br.png",
      "phoneLength": 11,
      "formatLength": 16
   },
   "IO": {
      "id": "IO",
      "name": "British Indian Ocean Territory",
      "code": "+246",
      "url": "https://flagcdn.com/w320/io.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "BN": {
      "id": "BN",
      "name": "Brunei Darussalam",
      "code": "+673",
      "url": "https://flagcdn.com/w320/bn.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "BG": {
      "id": "BG",
      "name": "Bulgaria",
      "code": "+359",
      "url": "https://flagcdn.com/w320/bg.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "BF": {
      "id": "BF",
      "name": "Burkina Faso",
      "code": "+226",
      "url": "https://flagcdn.com/w320/bf.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "BI": {
      "id": "BI",
      "name": "Burundi",
      "code": "+257",
      "url": "https://flagcdn.com/w320/bi.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "KH": {
      "id": "KH",
      "name": "Cambodia",
      "code": "+855",
      "url": "https://flagcdn.com/w320/kh.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "CM": {
      "id": "CM",
      "name": "Cameroon",
      "code": "+237",
      "url": "https://flagcdn.com/w320/cm.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "CA": {
      "id": "CA",
      "name": "Canada",
      "code": "+1",
      "url": "https://flagcdn.com/w320/ca.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "CV": {
      "id": "CV",
      "name": "Cape Verde",
      "code": "+238",
      "url": "https://flagcdn.com/w320/cv.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "KY": {
      "id": "KY",
      "name": "Cayman Islands",
      "code": "+1345",
      "url": "https://flagcdn.com/w320/ky.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "CF": {
      "id": "CF",
      "name": "Central African Republic",
      "code": "+236",
      "url": "https://flagcdn.com/w320/cf.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "TD": {
      "id": "TD",
      "name": "Chad",
      "code": "+235",
      "url": "https://flagcdn.com/w320/td.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "CL": {
      "id": "CL",
      "name": "Chile",
      "code": "+56",
      "url": "https://flagcdn.com/w320/cl.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "CN": {
      "id": "CN",
      "name": "China",
      "code": "+86",
      "url": "https://flagcdn.com/w320/cn.png",
      "phoneLength": 11,
      "formatLength": 16
   },
   "CX": {
      "id": "CX",
      "name": "Christmas Island",
      "code": "+61",
      "url": "https://flagcdn.com/w320/cx.png",
      "phoneLength": 6,
      "formatLength": 8
   },
   "CC": {
      "id": "CC",
      "name": "Cocos (Keeling) Islands",
      "code": "+61",
      "url": "https://flagcdn.com/w320/cc.png",
      "phoneLength": 6,
      "formatLength": 8
   },
   "CO": {
      "id": "CO",
      "name": "Colombia",
      "code": "+57",
      "url": "https://flagcdn.com/w320/co.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "KM": {
      "id": "KM",
      "name": "Comoros",
      "code": "+269",
      "url": "https://flagcdn.com/w320/km.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "CG": {
      "id": "CG",
      "name": "Congo",
      "code": "+242",
      "url": "https://flagcdn.com/w320/cg.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "CD": {
      "id": "CD",
      "name": "Congo, The Democratic Republic of the",
      "code": "+243",
      "url": "https://flagcdn.com/w320/cd.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "CK": {
      "id": "CK",
      "name": "Cook Islands",
      "code": "+682",
      "url": "https://flagcdn.com/w320/ck.png",
      "phoneLength": 5,
      "formatLength": 6
   },
   "CR": {
      "id": "CR",
      "name": "Costa Rica",
      "code": "+506",
      "url": "https://flagcdn.com/w320/cr.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "CI": {
      "id": "CI",
      "name": "Ivory Coast",
      "code": "+225",
      "url": "https://flagcdn.com/w320/ci.png",
      "phoneLength": 14,
      "formatLength": 14
   },
   "HR": {
      "id": "HR",
      "name": "Croatia",
      "code": "+385",
      "url": "https://flagcdn.com/w320/hr.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "CU": {
      "id": "CU",
      "name": "Cuba",
      "code": "+53",
      "url": "https://flagcdn.com/w320/cu.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "CY": {
      "id": "CY",
      "name": "Cyprus",
      "code": "+357",
      "url": "https://flagcdn.com/w320/cy.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "CZ": {
      "id": "CZ",
      "name": "Czech Republic",
      "code": "+420",
      "url": "https://flagcdn.com/w320/cz.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "DK": {
      "id": "DK",
      "name": "Denmark",
      "code": "+45",
      "url": "https://flagcdn.com/w320/dk.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "DJ": {
      "id": "DJ",
      "name": "Djibouti",
      "code": "+253",
      "url": "https://flagcdn.com/w320/dj.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "DM": {
      "id": "DM",
      "name": "Dominica",
      "code": "+1767",
      "url": "https://flagcdn.com/w320/dm.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "DO": {
      "id": "DO",
      "name": "Dominican Republic",
      "code": "+1849",
      "url": "https://flagcdn.com/w320/do.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "EC": {
      "id": "EC",
      "name": "Ecuador",
      "code": "+593",
      "url": "https://flagcdn.com/w320/ec.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "EG": {
      "id": "EG",
      "name": "Egypt",
      "code": "+20",
      "url": "https://flagcdn.com/w320/eg.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "SV": {
      "id": "SV",
      "name": "El Salvador",
      "code": "+503",
      "url": "https://flagcdn.com/w320/sv.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "GQ": {
      "id": "GQ",
      "name": "Equatorial Guinea",
      "code": "+240",
      "url": "https://flagcdn.com/w320/gq.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "ER": {
      "id": "ER",
      "name": "Eritrea",
      "code": "+291",
      "url": "https://flagcdn.com/w320/er.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "EE": {
      "id": "EE",
      "name": "Estonia",
      "code": "+372",
      "url": "https://flagcdn.com/w320/ee.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "ET": {
      "id": "ET",
      "name": "Ethiopia",
      "code": "+251",
      "url": "https://flagcdn.com/w320/et.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "FK": {
      "id": "FK",
      "name": "Falkland Islands",
      "code": "+500",
      "url": "https://flagcdn.com/w320/fk.png",
      "phoneLength": 5,
      "formatLength": 6
   },
   "FO": {
      "id": "FO",
      "name": "Faroe Islands",
      "code": "+298",
      "url": "https://flagcdn.com/w320/fo.png",
      "phoneLength": 6,
      "formatLength": 8
   },
   "FJ": {
      "id": "FJ",
      "name": "Fiji",
      "code": "+679",
      "url": "https://flagcdn.com/w320/fj.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "FI": {
      "id": "FI",
      "name": "Finland",
      "code": "+358",
      "url": "https://flagcdn.com/w320/fi.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "FR": {
      "id": "FR",
      "name": "France",
      "code": "+33",
      "url": "https://flagcdn.com/w320/fr.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "PF": {
      "id": "PF",
      "name": "French Polynesia",
      "code": "+689",
      "url": "https://flagcdn.com/w320/pf.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "TF": {
      "id": "TF",
      "name": "French Southern and Antarctic Lands",
      "code": "+262",
      "url": "https://flagcdn.com/w320/tf.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "GA": {
      "id": "GA",
      "name": "Gabon",
      "code": "+241",
      "url": "https://flagcdn.com/w320/ga.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "GM": {
      "id": "GM",
      "name": "Gambia",
      "code": "+220",
      "url": "https://flagcdn.com/w320/gm.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "GE": {
      "id": "GE",
      "name": "Georgia",
      "code": "+995",
      "url": "https://flagcdn.com/w320/ge.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "DE": {
      "id": "DE",
      "name": "Germany",
      "code": "+49",
      "url": "https://flagcdn.com/w320/de.png",
      "phoneLength": 11,
      "formatLength": 16,
      "minLength": 10,
      "maxLength": 11
   },
   "GH": {
      "id": "GH",
      "name": "Ghana",
      "code": "+233",
      "url": "https://flagcdn.com/w320/gh.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "GI": {
      "id": "GI",
      "name": "Gibraltar",
      "code": "+350",
      "url": "https://flagcdn.com/w320/gi.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "EL": {
      "id": "EL",
      "name": "Greece",
      "code": "+30",
      "url": "https://flagcdn.com/w320/el.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "GL": {
      "id": "GL",
      "name": "Greenland",
      "code": "+299",
      "url": "https://flagcdn.com/w320/gl.png",
      "phoneLength": 6,
      "formatLength": 8
   },
   "GD": {
      "id": "GD",
      "name": "Grenada",
      "code": "+1473",
      "url": "https://flagcdn.com/w320/gd.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "GP": {
      "id": "GP",
      "name": "Guadeloupe",
      "code": "+590",
      "url": "https://flagcdn.com/w320/gp.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "GU": {
      "id": "GU",
      "name": "Guam",
      "code": "+1671",
      "url": "https://flagcdn.com/w320/gu.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "GT": {
      "id": "GT",
      "name": "Guatemala",
      "code": "+502",
      "url": "https://flagcdn.com/w320/gt.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "GG": {
      "id": "GG",
      "name": "Guernsey",
      "code": "+44",
      "url": "https://flagcdn.com/w320/gg.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "GN": {
      "id": "GN",
      "name": "Guinea",
      "code": "+224",
      "url": "https://flagcdn.com/w320/gn.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "GW": {
      "id": "GW",
      "name": "Guinea-Bissau",
      "code": "+245",
      "url": "https://flagcdn.com/w320/gw.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "GY": {
      "id": "GY",
      "name": "Guyana",
      "code": "+592",
      "url": "https://flagcdn.com/w320/gy.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "HT": {
      "id": "HT",
      "name": "Haiti",
      "code": "+509",
      "url": "https://flagcdn.com/w320/ht.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "HM": {
      "id": "HM",
      "name": "Heard Island and McDonald Islands",
      "code": "+672",
      "url": "https://flagcdn.com/w320/hm.png",
      "phoneLength": 6,
      "formatLength": 8
   },
   "VA": {
      "id": "VA",
      "name": "Vatican City State (Holy See)",
      "code": "+379",
      "url": "https://flagcdn.com/w320/va.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "HN": {
      "id": "HN",
      "name": "Honduras",
      "code": "+504",
      "url": "https://flagcdn.com/w320/hn.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "HK": {
      "id": "HK",
      "name": "Hong Kong",
      "code": "+852",
      "url": "https://flagcdn.com/w320/hk.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "HU": {
      "id": "HU",
      "name": "Hungary",
      "code": "+36",
      "url": "https://flagcdn.com/w320/hu.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "IS": {
      "id": "IS",
      "name": "Iceland",
      "code": "+354",
      "url": "https://flagcdn.com/w320/is.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "IN": {
      "id": "IN",
      "name": "India",
      "code": "+91",
      "url": "https://flagcdn.com/w320/in.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "ID": {
      "id": "ID",
      "name": "Indonesia",
      "code": "+62",
      "url": "https://flagcdn.com/w320/id.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "IR": {
      "id": "IR",
      "name": "Iran, Islamic Republic of",
      "code": "+98",
      "url": "https://flagcdn.com/w320/ir.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "IQ": {
      "id": "IQ",
      "name": "Iraq",
      "code": "+964",
      "url": "https://flagcdn.com/w320/iq.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "IE": {
      "id": "IE",
      "name": "Ireland",
      "code": "+353",
      "url": "https://flagcdn.com/w320/ie.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "IM": {
      "id": "IM",
      "name": "Isle of Man",
      "code": "+44",
      "url": "https://flagcdn.com/w320/im.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "IL": {
      "id": "IL",
      "name": "Israel",
      "code": "+972",
      "url": "https://flagcdn.com/w320/il.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "IT": {
      "id": "IT",
      "name": "Italy",
      "code": "+39",
      "url": "https://flagcdn.com/w320/it.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "JM": {
      "id": "JM",
      "name": "Jamaica",
      "code": "+1876",
      "url": "https://flagcdn.com/w320/jm.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "JP": {
      "id": "JP",
      "name": "Japan",
      "code": "+81",
      "url": "https://flagcdn.com/w320/jp.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "JE": {
      "id": "JE",
      "name": "Jersey",
      "code": "+44",
      "url": "https://flagcdn.com/w320/je.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "JO": {
      "id": "JO",
      "name": "Jordan",
      "code": "+962",
      "url": "https://flagcdn.com/w320/jo.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "KZ": {
      "id": "KZ",
      "name": "Kazakhstan",
      "code": "+7",
      "url": "https://flagcdn.com/w320/kz.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "KE": {
      "id": "KE",
      "name": "Kenya",
      "code": "+254",
      "url": "https://flagcdn.com/w320/ke.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "KI": {
      "id": "KI",
      "name": "Kiribati",
      "code": "+686",
      "url": "https://flagcdn.com/w320/ki.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "KP": {
      "id": "KP",
      "name": "North Korea",
      "code": "+850",
      "url": "https://flagcdn.com/w320/kp.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "KR": {
      "id": "KR",
      "name": "South Korea",
      "code": "+82",
      "url": "https://flagcdn.com/w320/kr.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "KW": {
      "id": "KW",
      "name": "Kuwait",
      "code": "+965",
      "url": "https://flagcdn.com/w320/kw.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "KG": {
      "id": "KG",
      "name": "Kyrgyzstan",
      "code": "+996",
      "url": "https://flagcdn.com/w320/kg.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "LA": {
      "id": "LA",
      "name": "Laos",
      "code": "+856",
      "url": "https://flagcdn.com/w320/la.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "LV": {
      "id": "LV",
      "name": "Latvia",
      "code": "+371",
      "url": "https://flagcdn.com/w320/lv.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "LB": {
      "id": "LB",
      "name": "Lebanon",
      "code": "+961",
      "url": "https://flagcdn.com/w320/lb.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "LS": {
      "id": "LS",
      "name": "Lesotho",
      "code": "+266",
      "url": "https://flagcdn.com/w320/ls.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "LR": {
      "id": "LR",
      "name": "Liberia",
      "code": "+231",
      "url": "https://flagcdn.com/w320/lr.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "LY": {
      "id": "LY",
      "name": "Libyan Arab Jamahiriya",
      "code": "+218",
      "url": "https://flagcdn.com/w320/ly.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "LI": {
      "id": "LI",
      "name": "Liechtenstein",
      "code": "+423",
      "url": "https://flagcdn.com/w320/li.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "LT": {
      "id": "LT",
      "name": "Lithuania",
      "code": "+370",
      "url": "https://flagcdn.com/w320/lt.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "LU": {
      "id": "LU",
      "name": "Luxembourg",
      "code": "+352",
      "url": "https://flagcdn.com/w320/lu.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "MO": {
      "id": "MO",
      "name": "Macau",
      "code": "+853",
      "url": "https://flagcdn.com/w320/mo.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "MK": {
      "id": "MK",
      "name": "Macedonia, The Former Yugoslav Republic of",
      "code": "+389",
      "url": "https://flagcdn.com/w320/mk.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "MG": {
      "id": "MG",
      "name": "Madagascar",
      "code": "+261",
      "url": "https://flagcdn.com/w320/mg.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "MW": {
      "id": "MW",
      "name": "Malawi",
      "code": "+265",
      "url": "https://flagcdn.com/w320/mw.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "MY": {
      "id": "MY",
      "name": "Malaysia",
      "code": "+60",
      "url": "https://flagcdn.com/w320/my.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "MV": {
      "id": "MV",
      "name": "Maldives",
      "code": "+960",
      "url": "https://flagcdn.com/w320/mv.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "ML": {
      "id": "ML",
      "name": "Mali",
      "code": "+223",
      "url": "https://flagcdn.com/w320/ml.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "MT": {
      "id": "MT",
      "name": "Malta",
      "code": "+356",
      "url": "https://flagcdn.com/w320/mt.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "MH": {
      "id": "MH",
      "name": "Marshall Islands",
      "code": "+692",
      "url": "https://flagcdn.com/w320/mh.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "MQ": {
      "id": "MQ",
      "name": "Martinique",
      "code": "+596",
      "url": "https://flagcdn.com/w320/mq.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "MR": {
      "id": "MR",
      "name": "Mauritania",
      "code": "+222",
      "url": "https://flagcdn.com/w320/mr.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "MU": {
      "id": "MU",
      "name": "Mauritius",
      "code": "+230",
      "url": "https://flagcdn.com/w320/mu.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "YT": {
      "id": "YT",
      "name": "Mayotte",
      "code": "+262",
      "url": "https://flagcdn.com/w320/yt.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "MX": {
      "id": "MX",
      "name": "Mexico",
      "code": "+52",
      "url": "https://flagcdn.com/w320/mx.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "FM": {
      "id": "FM",
      "name": "Micronesia, Federated States of",
      "code": "+691",
      "url": "https://flagcdn.com/w320/fm.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "MD": {
      "id": "MD",
      "name": "Moldova, Republic of",
      "code": "+373",
      "url": "https://flagcdn.com/w320/md.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "MC": {
      "id": "MC",
      "name": "Monaco",
      "code": "+377",
      "url": "https://flagcdn.com/w320/mc.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "MN": {
      "id": "MN",
      "name": "Mongolia",
      "code": "+976",
      "url": "https://flagcdn.com/w320/mn.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "ME": {
      "id": "ME",
      "name": "Montenegro",
      "code": "+382",
      "url": "https://flagcdn.com/w320/me.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "MS": {
      "id": "MS",
      "name": "Montserrat",
      "code": "+1664",
      "url": "https://flagcdn.com/w320/ms.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "MA": {
      "id": "MA",
      "name": "Morocco",
      "code": "+212",
      "url": "https://flagcdn.com/w320/ma.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "MZ": {
      "id": "MZ",
      "name": "Mozambique",
      "code": "+258",
      "url": "https://flagcdn.com/w320/mz.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "MM": {
      "id": "MM",
      "name": "Myanmar",
      "code": "+95",
      "url": "https://flagcdn.com/w320/mm.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "NA": {
      "id": "NA",
      "name": "Namibia",
      "code": "+264",
      "url": "https://flagcdn.com/w320/na.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "NR": {
      "id": "NR",
      "name": "Nauru",
      "code": "+674",
      "url": "https://flagcdn.com/w320/nr.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "NP": {
      "id": "NP",
      "name": "Nepal",
      "code": "+977",
      "url": "https://flagcdn.com/w320/np.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "NL": {
      "id": "NL",
      "name": "Netherlands",
      "code": "+31",
      "url": "https://flagcdn.com/w320/nl.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "AN": {
      "id": "AN",
      "name": "Netherlands Antilles",
      "code": "+599",
      "url": "https://flagcdn.com/w320/an.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "NC": {
      "id": "NC",
      "name": "New Caledonia",
      "code": "+687",
      "url": "https://flagcdn.com/w320/nc.png",
      "phoneLength": 6,
      "formatLength": 8
   },
   "NZ": {
      "id": "NZ",
      "name": "New Zealand",
      "code": "+64",
      "url": "https://flagcdn.com/w320/nz.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "NI": {
      "id": "NI",
      "name": "Nicaragua",
      "code": "+505",
      "url": "https://flagcdn.com/w320/ni.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "NE": {
      "id": "NE",
      "name": "Niger",
      "code": "+227",
      "url": "https://flagcdn.com/w320/ne.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "NG": {
      "id": "NG",
      "name": "Nigeria",
      "code": "+234",
      "url": "https://flagcdn.com/w320/ng.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "NU": {
      "id": "NU",
      "name": "Niue",
      "code": "+683",
      "url": "https://flagcdn.com/w320/nu.png",
      "phoneLength": 4,
      "formatLength": 4
   },
   "NF": {
      "id": "NF",
      "name": "Norfolk Island",
      "code": "+672",
      "url": "https://flagcdn.com/w320/nf.png",
      "phoneLength": 6,
      "formatLength": 8
   },
   "MP": {
      "id": "MP",
      "name": "Northern Mariana Islands",
      "code": "+1670",
      "url": "https://flagcdn.com/w320/mp.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "NO": {
      "id": "NO",
      "name": "Norway",
      "code": "+47",
      "url": "https://flagcdn.com/w320/no.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "OM": {
      "id": "OM",
      "name": "Oman",
      "code": "+968",
      "url": "https://flagcdn.com/w320/om.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "PK": {
      "id": "PK",
      "name": "Pakistan",
      "code": "+92",
      "url": "https://flagcdn.com/w320/pk.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "PW": {
      "id": "PW",
      "name": "Palau",
      "code": "+680",
      "url": "https://flagcdn.com/w320/pw.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "PS": {
      "id": "PS",
      "name": "Palestinian Territory, Occupied",
      "code": "+970",
      "url": "https://flagcdn.com/w320/ps.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "PA": {
      "id": "PA",
      "name": "Panama",
      "code": "+507",
      "url": "https://flagcdn.com/w320/pa.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "PG": {
      "id": "PG",
      "name": "Papua New Guinea",
      "code": "+675",
      "url": "https://flagcdn.com/w320/pg.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "PY": {
      "id": "PY",
      "name": "Paraguay",
      "code": "+595",
      "url": "https://flagcdn.com/w320/py.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "PE": {
      "id": "PE",
      "name": "Peru",
      "code": "+51",
      "url": "https://flagcdn.com/w320/pe.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "PH": {
      "id": "PH",
      "name": "Philippines",
      "code": "+63",
      "url": "https://flagcdn.com/w320/ph.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "PN": {
      "id": "PN",
      "name": "Pitcairn",
      "code": "+870",
      "url": "https://flagcdn.com/w320/pn.png",
      "phoneLength": 14,
      "formatLength": 14
   },
   "PL": {
      "id": "PL",
      "name": "Poland",
      "code": "+48",
      "url": "https://flagcdn.com/w320/pl.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "PT": {
      "id": "PT",
      "name": "Portugal",
      "code": "+351",
      "url": "https://flagcdn.com/w320/pt.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "PR": {
      "id": "PR",
      "name": "Puerto Rico",
      "code": "+1939",
      "url": "https://flagcdn.com/w320/pr.png",
      "phoneLength": 14,
      "formatLength": 14
   },
   "QA": {
      "id": "QA",
      "name": "Qatar",
      "code": "+974",
      "url": "https://flagcdn.com/w320/qa.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "RE": {
      "id": "RE",
      "name": "Réunion",
      "code": "+262",
      "url": "https://flagcdn.com/w320/re.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "RO": {
      "id": "RO",
      "name": "Romania",
      "code": "+40",
      "url": "https://flagcdn.com/w320/ro.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "RU": {
      "id": "RU",
      "name": "Russia",
      "code": "+7",
      "url": "https://flagcdn.com/w320/ru.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "RW": {
      "id": "RW",
      "name": "Rwanda",
      "code": "+250",
      "url": "https://flagcdn.com/w320/rw.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "SH": {
      "id": "SH",
      "name": "Saint Helena, Ascension and Tristan Da Cunha",
      "code": "+290",
      "url": "https://flagcdn.com/w320/sh.png",
      "phoneLength": 5,
      "formatLength": 6
   },
   "KN": {
      "id": "KN",
      "name": "Saint Kitts and Nevis",
      "code": "+1869",
      "url": "https://flagcdn.com/w320/kn.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "LC": {
      "id": "LC",
      "name": "Saint Lucia",
      "code": "+1758",
      "url": "https://flagcdn.com/w320/lc.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "PM": {
      "id": "PM",
      "name": "Saint Pierre and Miquelon",
      "code": "+508",
      "url": "https://flagcdn.com/w320/pm.png",
      "phoneLength": 6,
      "formatLength": 8
   },
   "VC": {
      "id": "VC",
      "name": "Saint Vincent and the Grenadines",
      "code": "+1784",
      "url": "https://flagcdn.com/w320/vc.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "WS": {
      "id": "WS",
      "name": "Samoa",
      "code": "+685",
      "url": "https://flagcdn.com/w320/ws.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "SM": {
      "id": "SM",
      "name": "San Marino",
      "code": "+378",
      "url": "https://flagcdn.com/w320/sm.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "ST": {
      "id": "ST",
      "name": "Sao Tome and Principe",
      "code": "+239",
      "url": "https://flagcdn.com/w320/st.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "SA": {
      "id": "SA",
      "name": "Saudi Arabia",
      "code": "+966",
      "url": "https://flagcdn.com/w320/sa.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "SN": {
      "id": "SN",
      "name": "Senegal",
      "code": "+221",
      "url": "https://flagcdn.com/w320/sn.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "RS": {
      "id": "RS",
      "name": "Serbia",
      "code": "+381",
      "url": "https://flagcdn.com/w320/rs.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "SC": {
      "id": "SC",
      "name": "Seychelles",
      "code": "+248",
      "url": "https://flagcdn.com/w320/sc.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "SL": {
      "id": "SL",
      "name": "Sierra Leone",
      "code": "+232",
      "url": "https://flagcdn.com/w320/sl.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "SG": {
      "id": "SG",
      "name": "Singapore",
      "code": "+65",
      "url": "https://flagcdn.com/w320/sg.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "SK": {
      "id": "SK",
      "name": "Slovakia",
      "code": "+421",
      "url": "https://flagcdn.com/w320/sk.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "SI": {
      "id": "SI",
      "name": "Slovenia",
      "code": "+386",
      "url": "https://flagcdn.com/w320/si.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "SB": {
      "id": "SB",
      "name": "Solomon Islands",
      "code": "+677",
      "url": "https://flagcdn.com/w320/sb.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "SO": {
      "id": "SO",
      "name": "Somalia",
      "code": "+252",
      "url": "https://flagcdn.com/w320/so.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "ZA": {
      "id": "ZA",
      "name": "South Africa",
      "code": "+27",
      "url": "https://flagcdn.com/w320/za.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "GS": {
      "id": "GS",
      "name": "South Georgia and the South Sandwich Islands",
      "code": "+500",
      "url": "https://flagcdn.com/w320/gs.png",
      "phoneLength": 5,
      "formatLength": 6
   },
   "ES": {
      "id": "ES",
      "name": "Spain",
      "code": "+34",
      "url": "https://flagcdn.com/w320/es.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "LK": {
      "id": "LK",
      "name": "Sri Lanka",
      "code": "+94",
      "url": "https://flagcdn.com/w320/lk.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "SD": {
      "id": "SD",
      "name": "Sudan",
      "code": "+249",
      "url": "https://flagcdn.com/w320/sd.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "SR": {
      "id": "SR",
      "name": "Suriname",
      "code": "+597",
      "url": "https://flagcdn.com/w320/sr.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "SJ": {
      "id": "SJ",
      "name": "Svalbard and Jan Mayen",
      "code": "+47",
      "url": "https://flagcdn.com/w320/sj.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "SZ": {
      "id": "SZ",
      "name": "Swaziland",
      "code": "+268",
      "url": "https://flagcdn.com/w320/sz.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "SE": {
      "id": "SE",
      "name": "Sweden",
      "code": "+46",
      "url": "https://flagcdn.com/w320/se.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "CH": {
      "id": "CH",
      "name": "Switzerland",
      "code": "+41",
      "url": "https://flagcdn.com/w320/ch.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "SY": {
      "id": "SY",
      "name": "Syria",
      "code": "+963",
      "url": "https://flagcdn.com/w320/sy.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "TW": {
      "id": "TW",
      "name": "Taiwan",
      "code": "+886",
      "url": "https://flagcdn.com/w320/tw.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "TJ": {
      "id": "TJ",
      "name": "Tajikistan",
      "code": "+992",
      "url": "https://flagcdn.com/w320/tj.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "TZ": {
      "id": "TZ",
      "name": "Tanzania, United Republic of",
      "code": "+255",
      "url": "https://flagcdn.com/w320/tz.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "TH": {
      "id": "TH",
      "name": "Thailand",
      "code": "+66",
      "url": "https://flagcdn.com/w320/th.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "TL": {
      "id": "TL",
      "name": "Timor-Leste",
      "code": "+670",
      "url": "https://flagcdn.com/w320/tl.png",
      "phoneLength": 14,
      "formatLength": 14
   },
   "TG": {
      "id": "TG",
      "name": "Togo",
      "code": "+228",
      "url": "https://flagcdn.com/w320/tg.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "TK": {
      "id": "TK",
      "name": "Tokelau",
      "code": "+690",
      "url": "https://flagcdn.com/w320/tk.png",
      "phoneLength": 4,
      "formatLength": 4
   },
   "TO": {
      "id": "TO",
      "name": "Tonga",
      "code": "+676",
      "url": "https://flagcdn.com/w320/to.png",
      "phoneLength": 5,
      "formatLength": 6
   },
   "TT": {
      "id": "TT",
      "name": "Trinidad and Tobago",
      "code": "+1868",
      "url": "https://flagcdn.com/w320/tt.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "TN": {
      "id": "TN",
      "name": "Tunisia",
      "code": "+216",
      "url": "https://flagcdn.com/w320/tn.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "TR": {
      "id": "TR",
      "name": "Turkey",
      "code": "+90",
      "url": "https://flagcdn.com/w320/tr.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "TM": {
      "id": "TM",
      "name": "Turkmenistan",
      "code": "+993",
      "url": "https://flagcdn.com/w320/tm.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "TC": {
      "id": "TC",
      "name": "Turks and Caicos Islands",
      "code": "+1649",
      "url": "https://flagcdn.com/w320/tc.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "TV": {
      "id": "TV",
      "name": "Tuvalu",
      "code": "+688",
      "url": "https://flagcdn.com/w320/tv.png",
      "phoneLength": 5,
      "formatLength": 6
   },
   "UG": {
      "id": "UG",
      "name": "Uganda",
      "code": "+256",
      "url": "https://flagcdn.com/w320/ug.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "UA": {
      "id": "UA",
      "name": "Ukraine",
      "code": "+380",
      "url": "https://flagcdn.com/w320/ua.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "AE": {
      "id": "AE",
      "name": "United Arab Emirates",
      "code": "+971",
      "url": "https://flagcdn.com/w320/ae.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "GB": {
      "id": "GB",
      "name": "United Kingdom",
      "code": "+44",
      "url": "https://flagcdn.com/w320/gb.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "US": {
      "id": "US",
      "name": "United States",
      "code": "+1",
      "url": "https://flagcdn.com/w320/us.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "UM": {
      "id": "UM",
      "name": "United States Minor Outlying Islands",
      "code": "+1581",
      "url": "https://flagcdn.com/w320/um.png",
      "phoneLength": 14,
      "formatLength": 14
   },
   "UY": {
      "id": "UY",
      "name": "Uruguay",
      "code": "+598",
      "url": "https://flagcdn.com/w320/uy.png",
      "phoneLength": 8,
      "formatLength": 11
   },
   "UZ": {
      "id": "UZ",
      "name": "Uzbekistan",
      "code": "+998",
      "url": "https://flagcdn.com/w320/uz.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "VU": {
      "id": "VU",
      "name": "Vanuatu",
      "code": "+678",
      "url": "https://flagcdn.com/w320/vu.png",
      "phoneLength": 7,
      "formatLength": 10
   },
   "VE": {
      "id": "VE",
      "name": "Venezuela, Bolivarian Republic of",
      "code": "+58",
      "url": "https://flagcdn.com/w320/ve.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "VN": {
      "id": "VN",
      "name": "Vietnam",
      "code": "+84",
      "url": "https://flagcdn.com/w320/vn.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "VG": {
      "id": "VG",
      "name": "Virgin Islands, British",
      "code": "+1284",
      "url": "https://flagcdn.com/w320/vg.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "VI": {
      "id": "VI",
      "name": "Virgin Islands, U.S.",
      "code": "+1340",
      "url": "https://flagcdn.com/w320/vi.png",
      "phoneLength": 10,
      "formatLength": 14
   },
   "WF": {
      "id": "WF",
      "name": "Wallis and Futuna",
      "code": "+681",
      "url": "https://flagcdn.com/w320/wf.png",
      "phoneLength": 6,
      "formatLength": 8
   },
   "EH": {
      "id": "EH",
      "name": "Western Sahara",
      "code": "+732",
      "url": "https://flagcdn.com/w320/eh.png",
      "phoneLength": 14,
      "formatLength": 14
   },
   "YE": {
      "id": "YE",
      "name": "Yemen",
      "code": "+967",
      "url": "https://flagcdn.com/w320/ye.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "ZM": {
      "id": "ZM",
      "name": "Zambia",
      "code": "+260",
      "url": "https://flagcdn.com/w320/zm.png",
      "phoneLength": 9,
      "formatLength": 13
   },
   "ZW": {
      "id": "ZW",
      "name": "Zimbabwe",
      "code": "+263",
      "url": "https://flagcdn.com/w320/zw.png",
      "phoneLength": 9,
      "formatLength": 13
   }
}


export interface CountryListSchema {
    id: string;
    name: string;
    code: string;
    url: string;
    phoneLength: number;
    formatLength: number;
    minLength?: number;
    maxLength?: number;
}